import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import Heading from 'src/components/atoms/typo/Heading';
import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';
import HomeButton from 'src/components/atoms/button/HomeButton';

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class PushNotificationReservedPage extends Component<Props> {
  render() {
    return (
      <DefaultLayout {...this.props}>
        <Styled>
          <Heading tag={'h1'} text={'プッシュ通知の予約が完了しました'} />
          <div className="button_wrapper">
            <HomeButton />
          </div>
        </Styled>
      </DefaultLayout>
    );
  }
}

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  .button_wrapper {
    margin: ${StyleConfig.HELPER.M20} auto;
  }
`;

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PushNotificationReservedPage);
